export default {
  NOTIFICATION_LIST_REQUEST: 'APP/NOTIFICATION/NOTIFICATION_LIST_REQUEST',
  NOTIFICATION_LIST_SUCCESS: 'APP/NOTIFICATION/NOTIFICATION_LIST_SUCCESS',
  NOTIFICATION_LIST_ERROR: 'APP/NOTIFICATION/NOTIFICATION_LIST_ERROR',
};
